var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conversion-poster"},[_c('h1',[_vm._v("- 知识合伙人等你来赚钱 -")]),_c('img',{attrs:{"src":require("./images/poster.png"),"alt":""},on:{"click":function($event){return _vm.$router.push('/money')}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }